<template>

    <div>

        <div class="row row-cols-1 row-cols-lg-2 mb-4">

            <div class="col">
                <div class="card">
                    <div class="card-body">
                        <fieldset>
                            <legend>{{ __('Allgemein') }}</legend>
                            <text-input label="customer_number" v-model="form.customer_number" :error="form.errors.customer_number" :disabled="supplierCustomerRelation" />
                            <text-input label="internal_customer_number" v-model="form.internal_customer_number" :error="form.errors.internal_customer_number" />
                            <textarea-input label="notes" v-model="form.notes" :error="form.errors.notes" />
                        </fieldset>
                    </div>
                </div>
            </div>

        </div>

        <div class="d-flex align-items-center w-100">
            <submit-button :form="form" />
            <button type="button" class="btn link-danger" @click="destroy" v-if="supplierCustomerRelation">
                {{ __('Löschen') }}
            </button>
        </div>

    </div>

</template>

<script>
    import TextInput from '@/shared/Inputs/TextInput';
    import PriceInput from '@/shared/Inputs/PriceInput';
    import PercentInput from '@/shared/Inputs/PercentInput';
    import SelectInput from '@/shared/Inputs/SelectInput';
    import TextareaInput from '@/shared/Inputs/TextareaInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        props: [
            'form',
            'supplierCustomerRelation',
        ],
        data() {
            return {
            }
        },
        components: {
            TextInput,
            PriceInput,
            PercentInput,
            SelectInput,
            TextareaInput,
            CheckboxInput,
            SubmitButton,
        },
        watch: {
        },
        methods: {
            destroy() {
                if (confirm(this.__('Sind Sie sicher?'))) {
                    this.$inertia.delete(this.route('admin.customer-relations.destroy', this.supplierCustomerRelation.pivot.id));
                }
            },
        },
    }
</script>
